import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Login from "./pages/Login";
import ProtectedRoute from "./components/ProtectedRoute";
import Dashboard from "./pages/Dashboard";
import Layout from "./components/Layout";
import Report from "./pages/Report";
import Bridge from "./pages/Bridge";
import ApplicationTPE from "./pages/ApplicationTPE";
import Device from "./pages/Device";
import DevicePinpad from "./pages/DevicePinpad";
import SimType from "./pages/SimType";
import SolutionCode from "./pages/SolutionCode";
import ErrorCode from "./pages/ErrorCode";
import UserAdmin from "./pages/UserAdmin";
import DeviceBase from "./pages/DeviceBase";
import SerialPartCode from "./pages/SerialPartCode";
import PrivateRoute from "./components/PrivateRoute";
import UserGroup from "./pages/UserGroup";
import ResetPasswordForm from "./pages/ResetPasswordForm";
import AdminMessage from "./pages/AdminMessage";
import Mailling from "./pages/Mailling";
import LogsTable from "./pages/LogsTable";
import ForgotPassword from "./pages/ForgotPassword";
import GroupRI from "./pages/GroupRI";

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPasswordForm />} />
        <Route path="/" element={<ProtectedRoute><Layout /></ProtectedRoute>} >
          <Route index element={<Dashboard />} />
          <Route path="/report" element={<Report />} />
          <Route element={<PrivateRoute allowedRoles={["superadmin", "admin"]} />}>
            <Route path="/bridge" element={<Bridge />} />
            <Route path="/tpe" element={<ApplicationTPE />} />
            <Route path="/device" element={<Device />} />
            <Route path="/devicePinpad" element={<DevicePinpad />} />
            <Route path="/deviceBase" element={<DeviceBase />} />
            <Route path="/simType" element={<SimType />} />
            <Route path="/solutionCode" element={<SolutionCode />} />
            <Route path="/errorCode" element={<ErrorCode />} />
            <Route path="/serialPartCode" element={<SerialPartCode />} />
            <Route path="/user" element={<UserAdmin />} />
          </Route>
          <Route element={<PrivateRoute allowedRoles={["admin"]} />}>
            <Route path="/adminMessage" element={<AdminMessage />} />
          </Route>
          <Route element={<PrivateRoute allowedRoles={["superadmin"]} />}>
            <Route path="/mail" element={<Mailling />} />
            <Route path="/group" element={<UserGroup />} />
            <Route path="/groupRI" element={<GroupRI />} />
            <Route path="/logs" element={<LogsTable />} />
          </Route>
        </Route>
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </Router>
  );
};

export default App;
